<template>
  <SfSection :title-heading="topTitle.title" subtitle-heading="#YOURLOOK" class="InstagramFeed title">
    <div class="grid grid-images" v-if="katherinaSize">
      <div class="grid__row">
        <div class="grid__col" v-if="katherina.leftTop &&
          (katherina.leftTop.mobileImage || katherina.leftTop.image)
          ">
          <div @click="handleGoLink(katherina.leftBottom.link)">
            <SfImage v-if="isMobile" :src="katherina.leftTop.mobileImage" @click="handleGoLink(katherina.rightTop.link)"
              alt="katherina_trn" :width="160" :height="160">{{ katherina.leftTop.title }}</SfImage>
            <SfImage v-else @click="handleGoLink(katherina.rightTop.link)" :src="katherina.leftTop.image"
              alt="katherina_trn" :width="470" :height="470">
              {{ katherina.leftTop.title }}
            </SfImage>
          </div>
        </div>
        <div class="grid__col small" v-if="katherina.leftBottom &&
          (katherina.leftBottom.mobileImage || katherina.leftBottom.image)
          ">
          <div @click="handleGoLink(katherina.leftBottom.link)">
            <SfImage v-if="isMobile" @click="handleGoLink(katherina.leftBottom.link)"
              :src="katherina.leftBottom.mobileImage" alt="katherina_trn" :width="160" :height="160">{{
              katherina.leftBottom.title }}</SfImage>
            <SfImage v-else @click="handleGoLink(katherina.leftBottom.link)" :src="katherina.leftBottom.image"
              alt="katherina_trn" :width="470" :height="160">
              {{ katherina.leftBottom.title }}</SfImage>
          </div>
        </div>
      </div>
      <div class="grid__row">
        <div class="grid__col small" v-if="katherina.rightTop &&
          (katherina.rightTop.mobileImage || katherina.rightTop.image)
          ">
          <div @click="handleGoLink(katherina.rightTop.link)">
            <SfImage v-if="isMobile" :src="katherina.rightTop.mobileImage"
              @click="handleGoLink(katherina.rightTop.link)" alt="katherina_trn" :width="160" :height="160">{{
              katherina.rightTop.title }}</SfImage>
            <SfImage v-else :src="katherina.rightTop.image" alt="katherina_trn" :width="470" :height="160">
              {{ katherina.rightTop.title }}</SfImage>
          </div>
        </div>
        <div class="grid__col" v-if="katherina.rightBottom &&
          (katherina.rightBottom.mobileImage || katherina.rightBottom.image)
          ">
          <div @click="handleGoLink(katherina.rightBottom.link)">
            <SfImage v-if="isMobile" :src="katherina.rightBottom.mobileImage" alt="katherina_trn" :width="160"
              :height="160">{{ katherina.rightBottom.title }}</SfImage>
            <SfImage v-else :src="katherina.rightBottom.image" alt="katherina_trn" :width="470" :height="470">
              {{ katherina.rightBottom.title }}</SfImage>
          </div>
        </div>
      </div>
    </div>
  </SfSection>
</template>
<script>
import { addBasePath } from "@vue-storefront/core";
import {
  SfSection,
  SfImage,
  SfButton
} from "@storefront-ui/vue";
import { computed, useRouter } from "@nuxtjs/composition-api";
import { configGetters } from "@bee-hole/coms";
import { useUiState } from "~/composables";
export default {
  name: "InstagramFeed",
  components: {
    SfSection,
    SfImage,
    SfButton
  },
  setup(props, context) {
    const router = useRouter();
    const { isMobile } = useUiState();
    const katherina = computed(() => {
      return configGetters.getKatherina(context?.root?.$options?.$mallConfig?.mall_zx_home);
    });
    const katherinaSize = computed(() => {
      return Object.keys(katherina?.value).length;
    });
    const topTitle = computed(() => {
      return configGetters.getKatherinaTopBar(context?.root?.$options?.$mallConfig?.mall_zx_home);
    });
    const handleGoLink = (link) => {
      try {
        if (link) {
          link = link?.replace(/\s/g, '');
          if (link && link.indexOf('http') !== -1) {
            window.open(link, '_blank');
          } else {
            const localeAccountPath = context.root.localePath(link);
            router.push(localeAccountPath);
          }
        }
      } catch (e) {
        const localeAccountPath = context.root.localePath(link);
        router.push(localeAccountPath);
      }
    };
    return {
      isMobile,
      addBasePath,
      katherina,
      katherinaSize,
      topTitle,
      handleGoLink
    };
  }

};
</script>
<style lang="scss" scoped>
.InstagramFeed{
  border-top:0 !important;
}
.title {
  --heading-title-font-weight: var(--font-weight--semibold);
  --section-margin: var(--spacer-xl) 0;
  --section-content-margin: var(--spacer-xl) 0;
  --heading-title-font-size: var(--h2-font-size);

  @include for-desktop {
    --section-margin: var(--spacer-2xl) 0;
    --section-content-margin: var(--spacer-2xl) 0;
  }
}

.grid {
  display: flex !important;
  max-height: 20.625rem;
  width: 100%;
  justify-content: center;
  margin: 0;

  @include for-desktop {
    max-height: 40.625rem;
    max-width: 60rem;
    margin: 0 auto;
  }

  &__row {
    display: flex;
    flex-direction: column;
    &+& {
      margin-left: var(--spacer-xs);

      @include for-desktop {
        margin-left: var(--spacer-sm);
      }
    }
  }

  &__col {
    width: 10rem;
    height: 10rem;

    @include for-desktop {
      &.small {
        height: 10rem;
      }

      width: 29.375rem;
      height: 29.375rem;
    }

    &+& {
      margin-top: var(--spacer-xs);

      @include for-desktop {
        margin-top: var(--spacer-sm);
      }
    }
  }
}
.sf-banner-grid{
  &__col{
    @include for-mobile{
      margin-top: var(--spacer-sm);
    }
  }
}
</style>
